module.exports = __webpack_public_path__ + "static/media/PVA_Browser.0c427ac4.png";